import { render, staticRenderFns } from "./new_medical.vue?vue&type=template&id=5025cd35&scoped=true"
import script from "./new_medical.vue?vue&type=script&lang=js"
export * from "./new_medical.vue?vue&type=script&lang=js"
import style0 from "./new_medical.vue?vue&type=style&index=0&id=5025cd35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5025cd35",
  null
  
)

export default component.exports